import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { motion } from "framer-motion";

import Header from "../headers/light.js";
import BackToTop from "../BackToTop.js";
import { useTheme } from "../../contexts/ThemeContext.js";
// NOUVEAU — Modal partagé pour les demandes de démonstration
import DemoModal from "../cta/DemoModal.js";



import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import VisitorManagementIllustration from "../../images/visitor-management-illustration.png";
// import TrustedClientsImage from "../../images/customers-logo-strip.png";

const Container = styled.div`
  ${tw`relative min-h-screen`}
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  padding-top: 120px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3), transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3), transparent 50%),
                radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2), transparent 50%);
    animation: float 20s ease-in-out infinite;
  }
  
  @media (max-width: 1024px) {
    padding-top: 100px;
  }
`;

const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-20 md:py-24 relative z-10`;
const LeftColumn = tw.div`relative lg:w-5/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-end`;

const Heading = styled(motion.h1)`
  ${tw`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-6`}
  background: linear-gradient(135deg, #ffffff, #e0e7ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
  
  .highlight {
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Paragraph = styled(motion.p)`
  ${tw`my-5 lg:my-8 text-base xl:text-lg leading-relaxed`}
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Actions = styled.div`
  ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
  
  .premium-button {
    ${tw`w-full sm:w-auto px-8 py-4 text-white font-bold rounded-full`}
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    box-shadow: 0 8px 32px rgba(59, 130, 246, 0.4);
    border: 2px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      transform: translateY(-3px) scale(1.05);
      box-shadow: 0 12px 40px rgba(59, 130, 246, 0.6);
      border-color: rgba(255, 255, 255, 0.4);
    }
    
    &:active {
      transform: translateY(-1px);
    }
  }
  
  input {
    ${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300`}
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    color: white;
    backdrop-filter: blur(10px);
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }
    
    &:focus {
      border-color: rgba(255, 255, 255, 0.6);
      background: rgba(255, 255, 255, 0.15);
    }
  }
`;

const IllustrationContainer = styled(motion.div)`
  ${tw`flex justify-center lg:justify-end items-center`}
  
  img {
    ${tw`min-w-0 w-96 max-w-lg xl:max-w-3xl rounded-2xl shadow-2xl`}
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    border: 2px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    animation: float 6s ease-in-out infinite;
  }
`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 opacity-25`}
  fill: url(#gradient1);
  animation: float 8s ease-in-out infinite;
  filter: blur(1px);
`;

const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
  
  .particle {
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    animation: particleFloat 20s infinite linear;
  }
  
  @keyframes particleFloat {
    0% {
      transform: translateY(100vh) rotate(0deg);
      opacity: 0;
    }
    10% {
      opacity: 0.1;
    }
    90% {
      opacity: 0.1;
    }
    100% {
      transform: translateY(-100vh) rotate(360deg);
      opacity: 0;
    }
  }
`;

const TrustedClients = styled.div`
  ${tw`mt-12 lg:mt-20`}
  p {
    ${tw`uppercase text-sm lg:text-xs tracking-wider font-bold text-gray-500`}
  }
  img {
    ${tw`mt-4 w-full lg:pr-16 xl:pr-32 opacity-50`}
  }
`;

export default ({ roundedHeaderButton }) => {
  const { isDarkMode, colors } = useTheme();
  const [particles, setParticles] = useState([]);

  // NOUVEAU — Contrôle l'ouverture/fermeture du modal de démonstration
  const [showDemoModal, setShowDemoModal] = useState(false);


  useEffect(() => {
    const newParticles = Array.from({ length: 15 }, (_, i) => ({
      id: i,
      size: Math.random() * 4 + 2,
      left: Math.random() * 100,
      animationDelay: Math.random() * 20,
      animationDuration: Math.random() * 10 + 15
    }));
    setParticles(newParticles);
  }, []);


  // MODIFIÉ — Ouvre le modal au lieu de rediriger vers le dashboard
  const handleButtonClick = () => {
    setShowDemoModal(true);
  };


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <>
      <Header roundedHeaderButton={roundedHeaderButton} />
      <BackToTop />
      <Container>
        <AnimatedBackground>
          {particles.map(particle => (
            <div
              key={particle.id}
              className="particle"
              style={{
                width: `${particle.size}px`,
                height: `${particle.size}px`,
                left: `${particle.left}%`,
                animationDelay: `${particle.animationDelay}s`,
                animationDuration: `${particle.animationDuration}s`
              }}
            />
          ))}
        </AnimatedBackground>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <TwoColumn>
            <LeftColumn>
              <Heading variants={itemVariants}>
                Gestion des Visiteurs <span className="highlight">Simplifiée.</span>
              </Heading>
              <Paragraph variants={itemVariants}>
                Tanga offre une solution complète de gestion des visiteurs pour les entreprises dans tous les domaines. Améliorez l'efficacité, la sécurité et l'expérience des visiteurs avec notre plateforme innovante.
              </Paragraph>
              <Actions variants={itemVariants}>
                <button className="premium-button" onClick={handleButtonClick}>
                  Demander une Démo
                </button>
              </Actions>
            </LeftColumn>
            <RightColumn>
              <IllustrationContainer
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                <img src={VisitorManagementIllustration} alt="Illustration de Gestion des Visiteurs" />
              </IllustrationContainer>
            </RightColumn>
          </TwoColumn>
        </motion.div>

        <svg style={{ position: 'absolute', width: 0, height: 0 }}>
          <defs>
            <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.8" />
              <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.8" />
            </linearGradient>
          </defs>
        </svg>

        <DecoratorBlob1 />
      </Container>
      {/* NOUVEAU — Modal partagé de demande de démonstration */}
      <DemoModal
        isOpen={showDemoModal}
        onClose={() => setShowDemoModal(false)}
        productName="Tanga Access Log"
      />
    </>
  );
};